export default {
    namespace: 'stationGuide',
    defaultLanguage: 'en',
    defaultLocale: 'en-us',
    defaultCurrency: 'USD',
    supportedLocales: [
        'en-us',
    ],
    supportedCurrencies: [
        'USD',
    ],
};
